define("shared/components/shared/ui/report/industry-comparison", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <table class="o--table o--table--condensed u--m__b__0 qa__igReport_settings_comparisonPreviewTable">
    <thead>
      <tr>
        {{#each @headers as |header|}}
          <th class="u--text--sm u--text--light">{{header}}</th>
        {{/each}}
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="u--text--sm u--text--light">{{t "analytics.report.settings.industry.engagement.label"}}</td>
        <td class="u--text--sm u--text--black u--text--bold u--text--center">
          {{if @preview.profileAverageEngagement @preview.profileAverageEngagement "-"}}
        </td>
        <td class="u--text--sm u--text--black u--text--bold u--text--center">
          {{if @preview.industryAverageEngagement @preview.industryAverageEngagement "-"}}
        </td>
      </tr>
    </tbody>
  </table>
  <hr class="u--m__t__0 u--m__b__lg" />
  */
  {
    "id": "F0MXS/mx",
    "block": "[[[10,\"table\"],[14,0,\"o--table o--table--condensed u--m__b__0 qa__igReport_settings_comparisonPreviewTable\"],[12],[1,\"\\n  \"],[10,\"thead\"],[12],[1,\"\\n    \"],[10,\"tr\"],[12],[1,\"\\n\"],[42,[28,[37,1],[[28,[37,1],[[30,1]],null]],null],null,[[[1,\"        \"],[10,\"th\"],[14,0,\"u--text--sm u--text--light\"],[12],[1,[30,2]],[13],[1,\"\\n\"]],[2]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"tbody\"],[12],[1,\"\\n    \"],[10,\"tr\"],[12],[1,\"\\n      \"],[10,\"td\"],[14,0,\"u--text--sm u--text--light\"],[12],[1,[28,[35,2],[\"analytics.report.settings.industry.engagement.label\"],null]],[13],[1,\"\\n      \"],[10,\"td\"],[14,0,\"u--text--sm u--text--black u--text--bold u--text--center\"],[12],[1,\"\\n        \"],[1,[52,[30,3,[\"profileAverageEngagement\"]],[30,3,[\"profileAverageEngagement\"]],\"-\"]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"td\"],[14,0,\"u--text--sm u--text--black u--text--bold u--text--center\"],[12],[1,\"\\n        \"],[1,[52,[30,3,[\"industryAverageEngagement\"]],[30,3,[\"industryAverageEngagement\"]],\"-\"]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[10,\"hr\"],[14,0,\"u--m__t__0 u--m__b__lg\"],[12],[13]],[\"@headers\",\"header\",\"@preview\"],false,[\"each\",\"-track-array\",\"t\",\"if\"]]",
    "moduleName": "shared/components/shared/ui/report/industry-comparison.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});